import { useEffect } from 'react';

const useDocTitle = (title) => {
    useEffect(() => {
        document.title = title ? `${title} - Sklep` : 'Twój najlepszy sklep internetowy';
    }, [title]);

    return null;
};

export default useDocTitle;
